(function background_images() {
  document.querySelectorAll("[data-background-image]").forEach(element => {
    const desktop = element.getAttribute("data-background-image");
    const mobile = element.getAttribute("data-background-image-mobile");

    Theme.Helpers.preload(desktop);
    Theme.Helpers.preload(mobile);

    initialize();

    window.addEventListener("resize", Theme.Helpers.debounce(initialize, 150));

    function initialize() {
      let background;

      if (window.innerWidth <= 768) {
        if (mobile) {
          background = mobile;
                  element.style.backgroundSize = 'cover';

        } else {
          element.style.backgroundImage = '';
          return;
        }
      } else {
        background = desktop;
        element.style.backgroundSize = 'contain';

      }

      if (background) {
        element.style.backgroundImage = `url('${background}')`;
        element.style.backgroundPosition = 'center';
        element.style.backgroundRepeat = 'no-repeat';
      }
    }
  });
})();
